const scrollElementToPosition = (node, position = 'center') =>
  new Promise((resolve) => {
    let timeout = null;
    const scrollCheck = () => {
      clearTimeout(timeout);

      timeout = setTimeout(() => {
        window.removeEventListener('scroll', scrollCheck);
        resolve();
      }, 100);
    };

    window.addEventListener('scroll', scrollCheck);
    scrollCheck();

    node.scrollIntoView({ block: position });
  });

export default scrollElementToPosition;
